import React from "react";
import { Eye, X, AlertCircle } from "lucide-react";

const ColorBlindnessBanner = ({ colorBlindnessType, onReset }) => {
  if (colorBlindnessType === "normal") return null;

  const getVisionTypeDetails = (type) => {
    const types = {
      protanopia: { name: "Protanopia", description: "Red-blind", color: "from-red-500 to-orange-500" },
      deuteranopia: { name: "Deuteranopia", description: "Green-blind", color: "from-green-500 to-emerald-500" },
      tritanopia: { name: "Tritanopia", description: "Blue-blind", color: "from-blue-500 to-cyan-500" },
      achromatopsia: { name: "Achromatopsia", description: "Complete color blindness", color: "from-gray-500 to-gray-600" },
      protanomaly: { name: "Protanomaly", description: "Reduced red sensitivity", color: "from-red-400 to-orange-400" },
      deuteranomaly: { name: "Deuteranomaly", description: "Reduced green sensitivity", color: "from-green-400 to-emerald-400" },
      tritanomaly: { name: "Tritanomaly", description: "Reduced blue sensitivity", color: "from-blue-400 to-cyan-400" },
      achromatomaly: { name: "Achromatomaly", description: "Reduced color vision", color: "from-gray-400 to-slate-500" }
    };
    return types[type] || { name: type, description: "Vision simulation", color: "from-purple-500 to-indigo-500" };
  };

  const details = getVisionTypeDetails(colorBlindnessType);

  return (
    <div className={`fixed top-0 left-0 right-0 bg-gradient-to-r ${details.color} text-white p-3 z-50 shadow-lg border-b-2 border-white/20`}>
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-3 py-1.5">
            <Eye className="w-4 h-4" />
            <span className="text-sm font-medium">Vision Simulation</span>
          </div>

          <div className="flex items-center gap-2">
            <AlertCircle className="w-4 h-4 opacity-80" />
            <div className="flex flex-col">
              <span className="text-sm font-semibold">{details.name}</span>
              <span className="text-xs opacity-90">{details.description}</span>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="hidden sm:block text-xs opacity-90 bg-white/10 rounded-full px-2 py-1">
            Colors are simulated as they would appear to people with this condition
          </div>

          <button
            onClick={onReset}
            className="flex items-center gap-2 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white font-medium py-2 px-3 rounded-full transition-all duration-200 hover:scale-105 border border-white/20"
          >
            <X className="w-4 h-4" />
            <span className="text-sm">Reset to Normal</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColorBlindnessBanner;